import { useCallback, useState } from 'react';
import { Notification } from '../utils';
import socialAuthService from '../Services/social-auth.service';
import accessTokenService from '../Services/access-token.service';
import { useSearchParams } from 'react-router-dom';
import { redirectWithToken } from '../utils/redirect-with-token';

const HOME_PAGE_ROUTE = process.env.REACT_APP_PUBLIC_HOME_PAGE || '';

const useFacebookAuth = () => {
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const { dest } = Object.fromEntries(searchParams.entries());

  const facebookSignInHandler = useCallback(async () => {
    try {
      setLoading(true);

      const data = await socialAuthService.signInWithFacebook();
      const accessToken = data.result?.accessToken;

      if (data.type === 'error' || !accessToken) {
        Notification.error({
          description: data.result?.message || 'An error occurred while signing in with Facebook.',
        });
        return;
      }

      accessTokenService.set(accessToken, false);

      const destination = dest || HOME_PAGE_ROUTE;
      if (destination) {
        redirectWithToken(destination, accessToken);
      }
    } catch (error: any) {
      if (error?.code === 'auth/popup-closed-by-user' ||
        error?.code === 'auth/cancelled-popup-request') {
        return;
      }

      Notification.error({
        description: 'An unexpected error occurred while signing in with Facebook.',
      });
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [dest]);

  return { facebookSignInHandler, loading };
};

export default useFacebookAuth;